<template>
  <div v-if="show">
    <section class="extlinkcards" resmed-component-name="extlinkcards">
      <div class="component">
        <div
          class="col-md-12 col-xs-12 text-center headline-text"
          v-bind:class="`-mode-${[$root.mode]}`"
        >
          <div class="row">
            <div
              class="col-md-4 col-xs-6 elcardstrow"
              v-for="(item, index) in acf.items"
            >
              <div class="row">
                <a
                  v-bind:href="isUser ? item.cta_internal : item.cta"
                  target="_blank"
                  style="cursor: pointer; width: 100%; color: #ccc"
                  v-if="
                    $root.mode === 'lg' ||
                      $root.mode === 'xl' ||
                      $root.mode === 'md'
                  "
                >
                  <div
                    class="col-12 elcards"
                    :style="{ backgroundImage: `url(${item['bg-desktop']})` }"
                  >
                    <h5 class="elcardsh5 text-lg">{{ item.title }}</h5>
                  </div>
                </a>
              </div>
              <div class="row">
                <a
                  v-bind:href="item.cta"
                  target="_blank"
                  style="cursor: pointer; width: 100%; color: #ccc"
                  v-if="$root.mode === 'xs' || $root.mode === 'sm'"
                >
                  <div
                    class="col-12 elcards"
                    :style="{ backgroundImage: `url(${item['bg-desktop']})` }"
                  >
                    <!-- <h5 class="elcardsh5" >{{ item.title }}</h5> -->
                  </div>
                  <h5 class="elcardsh5m heading-xs">{{ item.title }}</h5>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- //container end -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "extlinkcards", // extlinkcards
  props: ["acf"],
  data() {
    return {
      items: this.acf.items,
      isUser: false,
    };
  },
  methods: {
    isResmedUser() {
      const email = this.$cookies.get("rocEmail");
      if (email && email.toLowerCase().includes("@resmed.")) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.isUser = this.isResmedUser();
  },
  computed: {
    show() {
      const role = this.$cookies.get("role");
      const b2bFirstName = this.$cookies.get("b2bFirstName");

      const roles = (role && role.split(",").map((r) => r.trim())) || [];
      const hasAnyTechnicalRole = roles.some(
        (r) =>
          r.includes("sleep_approved") ||
          r.includes("ventilator_approved") ||
          r.includes("oxygen_approved")
      );

      if (hasAnyTechnicalRole && b2bFirstName) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.extlinkcards {
  // padding: 0 4rem;
  @media (width: 768px) {
    padding: 0;
  }
  @media (max-width: 767px) {
    padding: 0 1rem;
  }
}

h2 {
  position: relative;
  margin-bottom: 0.5rem;

  @extend %eyebrow-center;
}

h4 {
  position: relative;
  margin-bottom: 0.625rem;

  @extend %eyebrow-left;
}

p {
  margin: 0 auto 1.5rem auto;
}
.elcardstrow {
  padding: 1em;

  @media (max-width: 768px) {
    padding: 0 1em;
    background-size: cover;
    width: 50%;
  }
}
.elcards {
  padding: 2em 0em;
  border: 1px solid;
  border-radius: 10px;
  padding-top: 4em;
  background-size: cover;

  @media (max-width: 992px) {
    padding: 2em 0em;
    padding-top: 2em;
    background-size: cover;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (width: 768px) {
    margin: 1rem 0;
  }

  @media (max-width: 767px) {
    height: 100px;
  }
}
.elcardsh5 {
  padding: 15px;
  background: #2121217a;
  color: #ffffff;

  @media screen and (max-width: 992px) and (min-width: 768px) {
    width: 100%;
    margin-bottom: 0;
  }
}
.elcardsh5m {
  padding: 6px 15px;
  text-align: center;
  color: #000000;
  font-size: 13px;
  margin-bottom: 1.2rem;

  @media screen and (max-width: 768px) {
    padding: 1rem 0 0 !important;
  }
}
</style>
